import VehicleStatus from '@/dossier/constants/VehicleStatus';
import { ABSTRACT_DOSSIER_SCHEMA } from '@/dossier/converters/dossierConverters';
import DossierSummary from '@/dossier/models/DossierSummary';
import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import Vehicle from '@/vehicle/models/Vehicle';
import { DossierSearchCriteria } from '../models/DossierSearchCriteria';

const SUMMARY_SCHEMA = {
  ...ABSTRACT_DOSSIER_SCHEMA,
  externalReference: 'dmsReference',
  partsPickingStatus: 'pickingStatus',
  mechanicIds: 'workedOnByIds',
  vehicle: (data: any) => {
    const vehicle = new Vehicle();
    vehicle.registrationNumber = data.registrationNumber;
    vehicle.modelDescription = data.modelDescription;
    return vehicle;
  },
  contacts: 'contacts',
  order: 'order',
  isPreCheckedIn: 'isPreCheckedIn',
};

export function parseDossierSummary(data: any): DossierSummary | null {
  return parseEntity(data, SUMMARY_SCHEMA, DossierSummary);
}

export function parseDossierSummaries(data: any): Array<DossierSummary> {
  return parseEntities(data, parseDossierSummary);
}

export function formatDossierSearchBody(criteria: DossierSearchCriteria): any {
  const searchByWorkStatusCriteria = 'workStatus' in criteria;
  const searchByVehicleStatusCriteria = 'vehicleStatus' in criteria;
  return {
    workStatus: searchByWorkStatusCriteria ? criteria.workStatus : null,
    objectStatus: searchByVehicleStatusCriteria ? criteria.vehicleStatus : null,
    moboOutletId: criteria.outletId,
    brandIds: criteria.brandIds ?? [],
    workshopPlanningTeamIds: criteria.workshopTeamIds ?? [],
    objectStatuses: searchByWorkStatusCriteria ? criteria.vehicleStatuses ?? [] : [],
    workStatuses: searchByVehicleStatusCriteria ? criteria.workStatuses ?? [] : [],
    tagIds: criteria.tagIds ?? [],
    assignedToIds: searchByWorkStatusCriteria || criteria.vehicleStatus !== VehicleStatus.EXPECTED ? criteria.assignedUserIds ?? [] : [],
    assignedToGroupIds: criteria.assignedGroupIds ?? [],
  };
}
